module.exports = __webpack_public_path__ + "img/napa-autocare.1a17940c.png";